import React, { useState } from "react";
import { classNames } from "repoV2/utils/common/render/classNames";
import { TextInput } from "@Modules/common/Form";
import { ButtonV2 } from "@Modules/common/ButtonV2";
import { BsCaretDownFill as DownIcon } from "@react-icons/all-files/bs/BsCaretDownFill";
import { evaluateHideComponent } from "@Modules/eventPage/utils/render";
import styles from "./discount.module.scss";
import commonStyles from "../../commonStyles.module.scss";
import { IDiscountField } from "./IDiscountField";
import { LoyaltyDiscountsSection } from "../..";

const DiscountField = ({
    hideComponent,
    showOn = "all",
    discountCodeInput,
    discountFieldDisabled,
    onDiscountCodeInputChange,
    onDiscountFieldFocus,
    applyButtonDisabled,
    discountApplied,
    discountError,
    handleNormalDiscountSubmit,
    loyaltyDiscountsSectionProps,
    isMobile,
}: IDiscountField.IProps) => {
    // only used in `showOn === "desktop"`
    const [isExpanded, setIsExpanded] = useState(false);

    if (evaluateHideComponent({ showOn, isMobile, hideComponent })) return null;

    return !isExpanded && !isMobile ? (
        <ButtonV2
            className={classNames(
                styles.applyDiscount,
                commonStyles.sidebarSectionTitle
            )}
            design="plain"
            onClick={() => setIsExpanded(true)}
        >
            <>
                Apply Coupon Code&nbsp;
                <DownIcon />
            </>
        </ButtonV2>
    ) : (
        <div>
            <form
                onSubmit={handleNormalDiscountSubmit}
                className={styles.discountForm}
            >
                <TextInput
                    type="text"
                    name="discount"
                    id="discount-discountField"
                    autoComplete="false"
                    className={styles.discountInput}
                    value={discountCodeInput}
                    onChange={onDiscountCodeInputChange}
                    success={discountApplied}
                    error={!!discountError}
                    onFocus={onDiscountFieldFocus}
                    disabled={discountFieldDisabled}
                    placeholder="Enter Coupon Code"
                />
                <ButtonV2
                    applyTheme
                    type="submit"
                    id="discount-discountApply"
                    disabled={applyButtonDisabled}
                    className={styles.discountSubmit}
                >
                    Apply
                </ButtonV2>
            </form>
            <div
                className={classNames(
                    styles.discountMessage,
                    discountError && styles.error,
                    discountApplied && styles.success
                )}
            >
                {discountError || ""}
                {discountApplied ? "Coupon Code Applied!" : ""}
            </div>
            <LoyaltyDiscountsSection {...loyaltyDiscountsSectionProps} />
        </div>
    );
};
export default DiscountField;
